import { createContext, useContext } from "react";
import { apiGet } from "./api";
export interface PublicProjectReader {
  token: string;
  projectId: string;
}
const Reader = createContext<PublicProjectReader | null>(null);
export const PublicProjectReaderProvider = Reader.Provider;
export function usePublicProjectReader() {
  return useContext(Reader);
}
export function publicQueryKey(
  reader: PublicProjectReader | null,
  key: readonly unknown[],
) {
  return reader ? ["public-project-reader", reader.token, ...key] : key;
}
/** Only explicitly supported project reads can use a secret viewer link. */
export async function projectReaderGet<T>(
  reader: PublicProjectReader | null,
  path: string,
): Promise<T> {
  if (!reader) return apiGet<T>(path);
  const base = `/public/projects/${encodeURIComponent(reader.token)}`;
  const [pathname, query] = path.split("?");
  if (pathname === `/projects/${reader.projectId}/tasks`)
    return apiGet<T>(`${base}/tasks${query ? `?${query}` : ""}`);
  for (const resource of ["members", "custom-fields", "task-dependencies"])
    if (pathname === `/projects/${reader.projectId}/${resource}`)
      return apiGet<T>(`${base}/${resource}`);
  const task = pathname?.match(
    /^\/tasks\/([\w-]+)(?:\/(comments|attachments))?$/,
  );
  if (task) {
    const value = await apiGet<T & { task?: T }>(
      `${base}/tasks/${task[1]}${task[2] ? `/${task[2]}` : ""}`,
    );
    return task[2] ? value : value.task!;
  }
  throw new Error("This resource is unavailable in the read-only project");
}
